import { ButtonPrimary } from "components/Atoms/Button";
import { PreviewPanelDetailRow } from "components/Atoms/details/PreviewPanelDetailRow";
import React, { useEffect } from "react";
import { PlaceholderContent } from "supportbeacon/articleplaceholders";
import { useApi } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";
import { PreviewPanel, PreviewPanelContent, PreviewPanelFooter, PreviewPanelHeader } from "../PreviewPanel";
import { PreviewPanelFreeFieldPermissionsSection } from "./PreviewPanelFreeFieldPermissionsSection";

interface FreeFieldPermissionProfilePreviewPanelProps {
  freeFieldPermissionProfileId: number
  environment: server.dto.Environments
}

const getTitle = (mainArea: server.dto.MainAreas) => {
  switch (mainArea) {
    case "show":
      return site.currentEnvironment.show.singular;
    case "production":
      return site.currentEnvironment.production.singular;
    default:
      return "";
  }
}

const FreeFieldPermissionProfilePreviewPanel = (props: FreeFieldPermissionProfilePreviewPanelProps) => {
  const { freeFieldPermissionProfileId, environment } = props;

  window.CoreApi.FreeFieldProfile.GetPreviewPanelData

  const api = useApi(() => window.CoreApi.FreeFieldProfile.GetPreviewPanelData(freeFieldPermissionProfileId), ["freeFieldProfile", freeFieldPermissionProfileId], {
    startEnabled: true
  });

  useEffect(() => {
    api.refetch();
  }, [freeFieldPermissionProfileId]);

  if (api.isInitialLoading) {
    return <>
      <PreviewPanelHeader title={RESX.FreeField.FreeFieldPermissionProfile} />
      <PreviewPanelContent>
        <PlaceholderContent />
      </PreviewPanelContent>
      <PreviewPanelFooter />
    </>;
  }

  const { freeFields, permissions, profile } = api.data.data;

  const environmentTypeTitle = profile.environment === "internal"
    ? RESX.UserType.InternalUsers
    : RESX.UserType.ExternalUsers;

  return <>
    <PreviewPanelHeader title={RESX.FreeField.FreeFieldPermissionProfile} />
    <PreviewPanelContent>
      <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Name}>
        <span>{profile.title}</span>
      </PreviewPanelDetailRow>

      <PreviewPanelDetailRow labelTop={RESX.GeneralLabels.Type}>
        <span>{environmentTypeTitle}</span>
      </PreviewPanelDetailRow>

      {freeFields.map(freeFieldArea => <React.Fragment key={freeFieldArea.mainArea}>
        <h3>{getTitle(freeFieldArea.mainArea)}</h3>
        <PreviewPanelFreeFieldPermissionsSection
          environment={environment}
          categories={freeFieldArea.categories}
          permissions={permissions}
        />
      </React.Fragment>)}

    </PreviewPanelContent>
    <PreviewPanelFooter>
      <ButtonPrimary href={routes.freeFieldProfile_Detail(profile.environment, freeFieldPermissionProfileId).absolute} label={RESX.Buttons.DetailView} />
    </PreviewPanelFooter>
  </>
}

export interface FreeFieldPermissionProfilePreviewProps {
  freeFieldPermissionProfileId: number
  environment: server.dto.Environments
  trigger: JSX.Element
}

export const FreeFieldPermissionProfilePreview = (props: FreeFieldPermissionProfilePreviewProps) => {
  return <PreviewPanel
    trigger={props.trigger}
    size="medium"
    id={`free-field-permission-profile-preview-${props.freeFieldPermissionProfileId}`}
  >
    <FreeFieldPermissionProfilePreviewPanel
      freeFieldPermissionProfileId={props.freeFieldPermissionProfileId}
      environment={props.environment}
    />
  </PreviewPanel>
}